import * as echarts from 'echarts'
import langES from 'echarts/i18n/langES'; // Import Spanish so we can register it

(function (Drupal, once) {
  'use strict'

  // Register the locale
  echarts.registerLocale('ES', langES)
  console.log('Spanish language registered for echarts')

  Drupal.behaviors.echartSamples = {
    attach: function (context) {
      once('chart-initialized', '.chart-component', context).forEach(chartElement => {
        console.log('Initializing echart')
        const myChart = echarts.init(chartElement)

        const configAttr = chartElement.dataset.chartConfig
        const config = configAttr ? JSON.parse(configAttr) : {}

        const option = {
          title: { text: config.title || 'Chart' },
          tooltip: {},
          xAxis: { data: config.xData || ['A', 'B', 'C'] },
          yAxis: {},
          series: [{
            name: config.seriesName || 'Data',
            type: config.type || 'bar',
            data: config.data || [10, 20, 30]
          }]
        }

        myChart.setOption(option)

        // Handle resize
        let resizeTimeout
        window.addEventListener('resize', function () {
          clearTimeout(resizeTimeout)
          resizeTimeout = setTimeout(function () {
            myChart.resize()
          }, 100)
        })
      })
    }
  }
})(Drupal, once)
